export default __webpack_public_path__ + "static/media/3B_360_1_alt.9c6f41cc.jpg";